<template>
  <div :class="$style['pt-promotion-table']">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" isAddPageToRouter v-loading="loading">
        <wt-table :labels="labels" :list="tableData">
            <template slot="before">
                <el-table-column label="促销活动名称">
                    <template slot-scope="scope">
                        {{scope.row.promotionData&&scope.row.promotionData.name}}
                    </template>
                </el-table-column>
                <el-table-column label="有效期" min-width="130" max-width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.startTime&&scope.row.endTime"><div>{{scope.row.startTime}} 至</div> {{scope.row.endTime}}</div>
                    </template>
                </el-table-column>
            </template>
            <slot/>
        </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-promotion-table'

export default {
  name: 'pt-promotion-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    labels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    selectTab: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      routerName: ''
    }
  },
  methods: {
    getTableData (page, next) {
      if (this.routerName !== 'promotion-coupon' || this.selectTab === 'promotion') {
        this.$emit('promotionList', page, next)
      }
    }
  },
  created () {
    this.routerName = this.$route.name
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-promotion-table{
    :global
.el-button{
    margin-right: 10px;
    +.el-button{
        margin-left: 0
    }
}
}
</style>
